import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class EnderecoValidation extends DefaultValidation {
	validate(model, pessoaSelected, refs) {
		let validated = true;


		if (Util.isNull(model.nome)) {
			refs.nomeInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.rsocial)&&(pessoaSelected == 1)) {
			refs.rsocialInput.focusedOut = true;
			validated = false;
		}
		if (!Util.isNull(model.telefone) && !Util.validatePhone(model.telefone)) {
			refs.telefoneInput.focusedOut = true;
			validated = false;
		}
		if (!Util.isNull(model.celular) && !Util.validatePhone(model.celular)) {
			refs.celularInput.focusedOut = true;
			validated = false;
		}
		if (!Util.isNull(model.fax) && !Util.validatePhone(model.fax)) {
			refs.faxInput.focusedOut = true;
			validated = false;
		}
		if (
			(Util.isNull(model.cnpjcpf) && pessoaSelected==1) || 
			(!Util.isNull(model.cnpjcpf) && pessoaSelected==1 && !Util.validateCnpj(model.cnpjcpf))
		) {
			refs.cnpjInput.focusedOut = true;
			validated = false;
		}
		if (
			(Util.isNull(model.cnpjcpf) && pessoaSelected==0) || 
			(!Util.isNull(model.cnpjcpf) && pessoaSelected==0 && !Util.validateCPF(model.cnpjcpf))
		) {
			refs.cpfInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.endereco)) {
			refs.enderecoInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.numero)) {
			refs.numeroInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.idcidade)) {
			refs.cidadeInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.idtipoendereco)) {
			refs.tipoEnderecoInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}